import { db } from '@/config/firebaseConfig'
import Vue from 'vue'

const state = {
  cartItemList: {}
}

const mutations = {
  'UPDATE_CART' (state, { item, quantity, isAdd, shopId }) {
    if (!state.cartItemList[shopId]) {
      Vue.set(state.cartItemList, shopId, [])
    }
    let record
    if (typeof item.variation !== 'undefined') {
      record = state.cartItemList[shopId].find(element => element.id === item.id && element.variation === item.variation)
    } else {
      record = state.cartItemList[shopId].find(element => element.id === item.id)
    }
    if (record) {
      if (isAdd) {
        record.quantity += quantity
      } else {
        record.quantity = quantity
      }
    } else {
      state.cartItemList[shopId].push({
        ...item,
        quantity
      })
    }
  },
  'SET_CART' (state, { productList, shopId }) {
    if (productList) {
      Vue.set(state.cartItemList, shopId, productList)
    } else {
      state.cartItemList = {}
    }
  },
  'REMOVE_CART_ITEM' (state, { item, shopId }) {
    const record = state.cartItemList[shopId].find(element => element.id === item.id)
    state.cartItemList[shopId].splice(state.cartItemList[shopId].indexOf(record), 1)
  }
}

const actions = {
  clearCart: ({ commit, getters }) => {
    const shopId = getters.shopId
    commit('SET_CART', { productList: [], shopId })
  },
  updateCart: ({ commit, getters }, { item, quantity, isAdd }) => {
    // TODO: Call service
    const shopId = getters.shopId
    console.log(shopId)
    commit('UPDATE_CART', { item, quantity, isAdd, shopId })
    if (isAdd) {
      let messageObj = {
        message: `Add ${item.title} to cart successfully`,
        messageClass: 'success',
        autoClose: true
      }
      commit('ADD_MESSAGE', messageObj)
    }
  },
  removeItemInCart: ({ commit, getters }, { item }) => {
    const shopId = getters.shopId
    commit('REMOVE_CART_ITEM', { item, shopId })
  },
  saveShoppingCart: ({ getters }, { uid, cartItemList }) => {
    return db().ref(`/cart/${getters.shopId}/${uid}`).set(cartItemList)
  },
  setCart: ({ commit, getters }, cart) => {
    const shopId = getters.shopId
    commit('REMOVE_CART_ITEM', { cart, shopId })
  }
}

const getters = {
  cartItemList: (state, getters) => {
    return state.cartItemList[getters.shopId] || []
  },
  cartValue: (state, getters) => {
    let res = 0
    if (state.cartItemList[getters.shopId]) {
      state.cartItemList[getters.shopId].map(item => {
        res += item.price * item.quantity
      })
    }
    return res
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
